export const FEATURE_RAMP_CONFIG = 'featureRampConfig';
export const FEATURE_RAMP_FREE_SHIP_SIDERAIL = 'freeshipsiderail';
